import { createRouteHelpers } from "../../shared/utils/createRouteHelpers";

import { PayrollRunsYear } from "./types";

const PARAMETER_PAYROLL_RUN_ID = "payrollRunId";
const PARAMETER_PAYSTUB_ID = "paystubId";

const PAYROLL_RUNS_PATH = "/member/payroll-runs";
const PAYROLL_RUNS_DASHBOARD_PATH = `${PAYROLL_RUNS_PATH}/:year`;
const PAYROLL_RUNS_DASHBOARD_ACTIVE_PAYROLLS_PATH = `${PAYROLL_RUNS_DASHBOARD_PATH}/active-payrolls`;
const PAYROLL_RUNS_DASHBOARD_HISTORY_PATH = `${PAYROLL_RUNS_DASHBOARD_PATH}/history`;
const PAYROLL_RUNS_DETAILS_PATH = `${PAYROLL_RUNS_DASHBOARD_PATH}/run/:${PARAMETER_PAYROLL_RUN_ID}`;
const PAYROLL_RUNS_PAYSTUB_PATH = `${PAYROLL_RUNS_DETAILS_PATH}/paystub/:${PARAMETER_PAYSTUB_ID}`;

export const routeHelperPayrollRuns = createRouteHelpers(PAYROLL_RUNS_PATH);

type PayrollRunsDashboardParams = {
  year: PayrollRunsYear;
};

export const routeHelperPayrollRunsDashboard =
  createRouteHelpers<PayrollRunsDashboardParams>(PAYROLL_RUNS_DASHBOARD_PATH);

export const routeHelperPayrollRunsDashboardActivePayrolls =
  createRouteHelpers<PayrollRunsDashboardParams>(
    PAYROLL_RUNS_DASHBOARD_ACTIVE_PAYROLLS_PATH
  );

export const routeHelperPayrollRunsDashboardHistory =
  createRouteHelpers<PayrollRunsDashboardParams>(
    PAYROLL_RUNS_DASHBOARD_HISTORY_PATH
  );

type PayrollRunsDetailsParams = PayrollRunsDashboardParams & {
  payrollRunId: string;
};

export const routeHelperPayrollRunsDetails =
  createRouteHelpers<PayrollRunsDetailsParams>(PAYROLL_RUNS_DETAILS_PATH);

type PayrollRunsPaystubParams = PayrollRunsDetailsParams & {
  paystubId: string;
};

export const routeHelperPayrollRunsPaystub =
  createRouteHelpers<PayrollRunsPaystubParams>(PAYROLL_RUNS_PAYSTUB_PATH);
